<template>
	<div :class="['integration-card', 'is-' + elemState.class]">
		<div class="integration-card__container">
			<div
				class="integration-card__status"
				:title="elemState.title + ' Site BOD'"
			>
				<i :class="['icon', 'icon-' + elemState.icon]"></i>
			</div>
			<div class="integration-card__main">
				<span class="integration-card__name">
					{{ source.bodType }}
					{{ source.bodVersion }}
				</span>
				<span class="integration-card__integration">
					{{ source.integration }}
				</span>
			</div>
		</div>
		<ActionsSet
			class="integration-card__actions"
			:id="`${uid}_action`"
			:variant="variant"
			:options="actions"
		/>
	</div>
</template>

<script>
import ActionsSet from '@/site-components/actions-set/actions-set';
import ValidatePermissions from '@/sections/integration/validate-permission-mixins';
import { mapGetters, mapActions } from 'vuex';
//constants
import {
	MODULE_NAME,
	SET_SITEBOD
} from '@/sections/integration/integrations-mutation-types';
// libraries
import { formatDate } from '@/utils/datetime';
import { sub } from 'date-fns';
import _ from 'lodash';

export default {
	name: 'SiteBodCard',
	inheritAttrs: false,
	mixins: [ValidatePermissions],
	props: {
		source: {
			type: Object,
			default: () => {}
		}
	},
	components: {
		ActionsSet
	},
	computed: {
		...mapGetters('integrations', ['thirdparty']),
		elemState() {
			if (!this.source.active) {
				return {
					class: 'inactive',
					icon: 'check-indeterminate',
					title: 'Inactive'
				};
			} else {
				return {
					class: 'active',
					icon: 'checkbox',
					title: 'Active'
				};
			}
		},

		actions() {
			return [
				{
					id: 1,
					action: this.edit,
					title: 'Select to go to integration settings',
					iconClass: 'icon icon-manage',
					label: 'Settings',
					type: 'anchor',
					visible: true,
					disabled: !this.canUpdate
				},
				{
					id: 2,
					action: this.remove,
					title: 'Select to remove Site Bod',
					iconClass: 'icon icon-delete-glenn',
					label: 'Remove',
					type: 'anchor',
					visible: true,
					disabled: !this.canDelete
				},
				{
					id: 3,
					action: this.showTransactions,
					iconClass: 'icon icon-transaction',
					label: 'Transactions',
					title: 'Select to go to the transactions page',
					type: 'anchor',
					visible: true
				}
			];
		}
	},
	methods: {
		...mapActions(MODULE_NAME, ['getThirdPartyById']),

		edit() {
			this.$store.dispatch(`${MODULE_NAME}/${SET_SITEBOD}`, {
				...this.source
			});
		},
		remove() {
			if (!this.canDelete) {
				this.$router.push('/access-denied');
				return;
			}

			this.$emit('remove', this.source);
		},
		async showTransactions() {
			let thirdPartyId = this.$route.params.thirdPartyId;
			const integrationId = this.$route.params.integrationId;

			if (_.isEmpty(this.thirdparty)) {
				const id = parseInt(thirdPartyId);
				await this.getThirdPartyById(id);
			}
			const { partyId, companyId, dealershipGroupGuid } = this.thirdparty;

			this.$router.push({
				path: `/integrations/thirdparties/${partyId}/${thirdPartyId}/${integrationId}/${this.source.id}/transactions`,

				query: {
					dealershipGroupGuid: dealershipGroupGuid,
					bodType: this.source.bodType,
					companyId: companyId,
					minDatetime: formatDate(
						new Date(sub(new Date(), { weeks: 1 }))
					),
					maxDatetime: formatDate(new Date())
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * Results Card
	* Can use SCSS variables = TRUE
	* [Table of Contents]
    *
    * BASE
    * BASE DESKTOP
 */

/*------------------------------------*\
  #BASE
\*------------------------------------*/
@import '@/scss/5-objects/_cards.scss';

.integration-card {
	@include card;
	display: grid;
	@include mq($until: md) {
		grid-template-rows: auto;
		row-gap: $gutter-lg;
	}

	&__container {
		display: flex;
	}
	&__main {
		font-weight: $medium-font-weight;
		font-size: $default-font-size;
	}

	&.is-inactive {
		.integration-card__status {
			@include text-contrast($neutral-3, $white, $black);
			background: $neutral-3;
		}
	}

	&__status {
		color: $white;
		margin-right: $gutter-lg;
		@include create-circle(16px, 16px, $ui-positive);
		@include vertical-horizontal-center-with-flex;
	}

	&__name,
	&__integration {
		display: block;
	}

	&__integration {
		font-size: $default-font-size - 2;
		font-weight: $default-font-weight;
	}
}

/*------------------------------------*\
  #BASE TABLET-UP
\*------------------------------------*/
@include mq($from: md) {
	.integration-card {
		column-gap: $gutter-lg;
		grid-template-columns: auto 1fr;
	}
}
</style>
